document.querySelectorAll('.wpl-tabs').forEach((tabs) => {
	const btns = tabs.querySelectorAll('.tab-btn');
	const panels = tabs.querySelectorAll('.tab-panel');

	btns.forEach((btn) => {
		btn.addEventListener('click', () => {
			const tab = btn.dataset.tab;

			btns.forEach((b) => b.classList.remove('active'));
			panels.forEach((p) => p.classList.remove('active'));

			btn.classList.add('active');
			document.getElementById(tab).classList.add('active');
		});
	});
});
